//Import required modules
import React from 'react';
import PropTypes from 'prop-types'

//Import Components
import ColorCircle from './ColorCircle'
import { selectAllColors, removePalette } from '../../store/actions';

//ColorRow Component
const ColorRow = ({colorArr, colorRowId, selectAll}, {store}) =>
{
    let userWindow = store.getState().userWindow;
    return (
    <div>
        <div style={{width: userWindow.rowWidth,
                        height: userWindow.rowHeight}}>

            <svg style={{width: userWindow.rowWidth,
                        height: userWindow.rowHeight}}>

                <text className={`btn-add-all ${store.getState().theme}`}
                        x={userWindow.selectX}
                        y={userWindow.selectY}
                        textAnchor='middle'
                        style={{fontSize: `${userWindow.fontSize}px`}}
                        title={`${selectAll?'Deselect':'Select'} all colors in this palette`}
                        onClick={() => store.dispatch(selectAllColors(store.getState().colorArr, colorRowId, selectAll, userWindow))}>{selectAll?'Deselect All':'Select All'}</text>

                <text className={`btn-remove-all ${store.getState().theme}`}
                    x={userWindow.removeX}
                    y={userWindow.removeY}
                    textAnchor='middle'
                    style={{fontSize: `${userWindow.fontSize}px`}}
                    title='Remove this palette'
                    onClick={() => store.dispatch(removePalette(colorRowId))}>Remove Palette</text>

                <g transform="translate(0,0)">
                    {
                    colorArr.map((d, i) => <ColorCircle key={i} 
                                                        {...d}/>)
                    }
                </g>

            </svg>

        </div>
        <hr className={`${store.getState().theme}`}/>
    </div>

    )
}

ColorRow.contextTypes = {
    store: PropTypes.object
}

export default ColorRow